import React from 'react';
import { uid } from 'react-uid';
import SendGridLink from '../SendGridLink';
import { StyledFooterLinks } from './styles';

const FooterLinks = ({ menu }) => (
  <StyledFooterLinks>
    {menu.map((navItem) => (
      <li key={uid(navItem)}>
        <SendGridLink to={navItem.slug}>{navItem.title}</SendGridLink>
      </li>
    ))}
  </StyledFooterLinks>
);

export default FooterLinks;
